module.exports = __webpack_public_path__ + "img/1499631337.8bc15c1a.jpg";